import Indicator from '../Indicator';
import LineMarker from '../markers/LineMarker';
import BandMarker from '../markers/BandMarker';

/** Stochastics indicator */
export default class StochasticsIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} dataSeries - Indicator data series
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 */
	_getDefaultParams() {
		return {
			id: 'stochastics',
			name: 'Stochastics',
			dataSeries: 'stochastick',
			description:
				'Stochastics show periods when a stock is overbought or oversold.',
			inputs: [
				{ name: 'kperiod', value: 5 },
				{ name: 'smoothing', value: 3 },
				{ name: 'dperiod', value: 3 }
			],
			bands: [
				{
					labelTranslationKey: 'band.overbought',
					valHigh: 100,
					valLow: 80
				},
				{
					labelTranslationKey: 'band.oversold',
					valHigh: 20,
					valLow: 0
				}
			],
			componentSeries: [
				{ id: 'stochastick' },
				{ id: 'stochasticd', styleRef: 'd' }
			]
		};
	}

	/** @return {number} 0 */
	getRangeMin() {
		return 0;
	}

	/** @return {number} 100 */
	getRangeMax() {
		return 100;
	}

	/**
	 * @return {object}
	 * @property {LineMarker} lineK
	 * @property {LineMarker} lineD
	 * @property {BandMarker} overbought
	 * @property {BandMarker} oversold
	 */
	_getMarkers() {
		return {
			lineD: new LineMarker(),
			lineK: new LineMarker(),
			overbought: new BandMarker(this.params.bands[0], this.panel),
			oversold: new BandMarker(this.params.bands[1], this.panel)
		};
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		const { style } = this.params;

		this.markers.overbought.render(this.panel, style.overbought);
		this.markers.oversold.render(this.panel, style.oversold);

		this._renderLineMarker({
			dataMap: this._getDataMap(data.stochastics, 'stochastick'),
			marker: this.markers.lineK,
			sessionType
		});

		this._renderLineMarker({
			dataMap: this._getDataMap(data.stochastics, 'stochasticd'),
			marker: this.markers.lineD,
			dataKey: 'd',
			sessionType
		});
	}
}
